module.exports = __webpack_public_path__ + "static/img/logo_color_font.aa851b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/logo_color_font.png
// module id = CuME
// module chunks = 6